/* Twosisters website chat widget — no dependencies. */
(function () {
  'use strict';
  var root = document.getElementById('ts-chat');
  if (!root || root.dataset.ready) return;
  root.dataset.ready = '1';

  var ENDPOINT = (root.dataset.endpoint || '').replace(/\/+$/, '');
  var PRODUCT = root.dataset.productHandle || '';
  var PRODUCT_TITLE = root.dataset.productTitle || '';
  var STORE_KEY = 'tsChat.v1';
  var MAX_KEEP = 30;

  var GREETING = "Hi, I'm the Twosisters assistant. I can help with sizing and how to measure, finding a dress, delivery, returns and your order status. What can I help with?";
  var CHIPS = PRODUCT
    ? ['What size should I get?', 'How do I measure myself?', 'Is this dress stretchy?', "Where's my order?", 'Returns']
    : ['Help me with sizing', 'How do I measure myself?', 'Wedding guest dresses', "Where's my order?", 'Returns'];

  // Instant answers (Shopify admin → Content → Metaobjects → Chat answers → "Quick button").
  // Tapping one of these buttons shows the saved answer straight away, with no AI call.
  var QUICK = {};
  try {
    var qEl = document.getElementById('ts-chat-quick');
    JSON.parse(qEl ? qEl.textContent : '[]').forEach(function (q) {
      if (!q || !q.label || !q.answer) return;
      var label = String(q.label).trim();
      QUICK[label.toLowerCase()] = String(q.answer);
      var known = CHIPS.some(function (c) { return c.toLowerCase() === label.toLowerCase(); });
      if (!known && CHIPS.length < 6) CHIPS.push(label);
    });
  } catch (e) { /* ignore */ }

  // ---------- storage (per-tab, optional) ----------
  function load() {
    try { var s = JSON.parse(sessionStorage.getItem(STORE_KEY) || 'null'); return s && Array.isArray(s.messages) ? s : null; } catch (e) { return null; }
  }
  function save() {
    try { sessionStorage.setItem(STORE_KEY, JSON.stringify({ messages: state.messages.slice(-MAX_KEEP), open: state.open })); } catch (e) { /* ignore */ }
  }
  var saved = load();
  var state = { messages: saved ? saved.messages : [], open: saved ? saved.open : false, busy: false };

  // ---------- safe text → HTML ----------
  function esc(s) {
    return String(s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }
  function safeUrl(u) {
    try {
      var url = new URL(u, location.origin);
      if (url.protocol !== 'https:' && url.protocol !== 'http:' && url.protocol !== 'mailto:') return null;
      return url.href;
    } catch (e) { return null; }
  }
  function link(href, text) {
    var url = safeUrl(href);
    if (!url) return text;
    var internal = url.indexOf(location.origin) === 0 || /twosistersthelabel\.com/i.test(url);
    return '<a href="' + esc(url) + '"' + (internal ? '' : ' target="_blank" rel="noopener noreferrer"') + '>' + text + '</a>';
  }
  function inline(s) {
    // s is already escaped
    var tokens = [];
    s = s.replace(/\[([^\]]{1,200})\]\(([^)\s]{1,500})\)/g, function (_, t, h) {
      tokens.push(link(h.replace(/&amp;/g, '&'), t)); return '\u0000' + (tokens.length - 1) + '\u0000';
    });
    s = s.replace(/(https?:\/\/[^\s<]+[^\s<.,;:!?)])/g, function (m) {
      tokens.push(link(m.replace(/&amp;/g, '&'), m)); return '\u0000' + (tokens.length - 1) + '\u0000';
    });
    s = s.replace(/\b([\w.+-]+@[\w-]+\.[\w.-]+\w)\b/g, function (m) {
      tokens.push(link('mailto:' + m, m)); return '\u0000' + (tokens.length - 1) + '\u0000';
    });
    s = s.replace(/\*\*([^*]+)\*\*/g, '<strong>$1</strong>');
    return s.replace(/\u0000(\d+)\u0000/g, function (_, i) { return tokens[+i]; });
  }
  function render(text) {
    var lines = esc(text).split(/\n/);
    var html = '', list = null;
    function close() { if (list) { html += '</' + list + '>'; list = null; } }
    lines.forEach(function (line) {
      var m;
      if ((m = line.match(/^\s*[-•*]\s+(.*)/))) {
        if (list !== 'ul') { close(); html += '<ul>'; list = 'ul'; }
        html += '<li>' + inline(m[1]) + '</li>';
      } else if ((m = line.match(/^\s*\d+[.)]\s+(.*)/))) {
        if (list !== 'ol') { close(); html += '<ol>'; list = 'ol'; }
        html += '<li>' + inline(m[1]) + '</li>';
      } else if (line.trim() === '') {
        close();
      } else {
        close(); html += '<p>' + inline(line.replace(/^#{1,4}\s+/, '')) + '</p>';
      }
    });
    close();
    return html;
  }

  // ---------- DOM ----------
  var ICON_CHAT = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M21 12a8 8 0 0 1-11.6 7.1L4 20l1-4.6A8 8 0 1 1 21 12z"/></svg>';
  var ICON_SEND = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12h14M13 6l6 6-6 6"/></svg>';

  root.innerHTML =
    '<button class="tsc-launcher" type="button" aria-controls="tsc-panel" aria-expanded="false">' + ICON_CHAT + '<span class="tsc-label">Need help</span></button>' +
    '<section class="tsc-panel" id="tsc-panel" role="dialog" aria-label="Twosisters chat" aria-modal="false">' +
      '<header class="tsc-head"><h2>Twosisters</h2><p>Sizing, orders, delivery &amp; returns</p>' +
      '<button class="tsc-new" type="button" hidden>New chat</button>' +
      '<button class="tsc-close" type="button" aria-label="Close chat">&times;</button></header>' +
      '<div class="tsc-body" aria-live="polite"></div>' +
      '<footer class="tsc-foot"><form class="tsc-form">' +
        '<textarea class="tsc-input" rows="1" maxlength="1200" placeholder="Type your question…" aria-label="Your message"></textarea>' +
        '<button class="tsc-send" type="submit" aria-label="Send">' + ICON_SEND + '</button></form>' +
        '<button class="tsc-team" type="button">Prefer a person? Email our team</button></footer>' +
    '</section>';

  var launcher = root.querySelector('.tsc-launcher');
  var panel = root.querySelector('.tsc-panel');
  var body = root.querySelector('.tsc-body');
  var form = root.querySelector('.tsc-form');
  var input = root.querySelector('.tsc-input');
  var sendBtn = root.querySelector('.tsc-send');
  var newBtn = root.querySelector('.tsc-new');

  function el(tag, cls, html) { var n = document.createElement(tag); if (cls) n.className = cls; if (html != null) n.innerHTML = html; return n; }
  function scroll() { body.scrollTop = body.scrollHeight; }

  function addBubble(role, text) {
    var n = el('div', 'tsc-msg ' + (role === 'user' ? 'tsc-user' : 'tsc-bot'));
    if (role === 'user') n.textContent = text; else n.innerHTML = render(text);
    body.appendChild(n); scroll(); return n;
  }

  function drawAll() {
    body.innerHTML = '';
    addBubble('assistant', GREETING);
    if (!state.messages.length) {
      var chips = el('div', 'tsc-chips');
      CHIPS.forEach(function (c) {
        var b = el('button', 'tsc-chip'); b.type = 'button'; b.textContent = c;
        b.addEventListener('click', function () {
          chips.remove();
          var instant = QUICK[c.toLowerCase()];
          if (instant) quickAnswer(c, instant); else send(c);
        });
        chips.appendChild(b);
      });
      body.appendChild(chips);
    }
    state.messages.forEach(function (m) { addBubble(m.role, m.content); });
    newBtn.hidden = !state.messages.length;
  }

  function setOpen(open) {
    state.open = open;
    panel.classList.toggle('tsc-open', open);
    launcher.setAttribute('aria-expanded', String(open));
    if (open) { scroll(); setTimeout(function () { input.focus(); }, 50); }
    save();
  }

  // ---------- network ----------
  function post(path, payload) {
    var ctrl = window.AbortController ? new AbortController() : null;
    var timer = ctrl ? setTimeout(function () { ctrl.abort(); }, 45000) : null;
    return fetch(ENDPOINT + path, {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload), signal: ctrl ? ctrl.signal : undefined,
    }).then(function (r) {
      if (timer) clearTimeout(timer);
      return r.json().catch(function () { return {}; }).then(function (j) { j._status = r.status; return j; });
    });
  }

  function send(text) {
    text = String(text || '').trim();
    if (!text || state.busy) return;
    state.busy = true; sendBtn.disabled = true;
    var chips = body.querySelector('.tsc-chips'); if (chips) chips.remove();
    state.messages.push({ role: 'user', content: text.slice(0, 1200) });
    addBubble('user', text); save();
    newBtn.hidden = false;
    input.value = ''; autosize();

    var typing = el('div', 'tsc-msg tsc-bot tsc-typing', '<span></span><span></span><span></span>');
    body.appendChild(typing); scroll();

    post('/message', {
      messages: state.messages.slice(-20),
      context: { pageUrl: location.href.split('#')[0], productHandle: PRODUCT, productTitle: PRODUCT_TITLE },
    }).then(function (res) {
      typing.remove();
      var reply = res.reply || "Sorry, something went wrong. Please try again or email sales@twosistersthelabel.com.";
      state.messages.push({ role: 'assistant', content: reply });
      addBubble('assistant', reply);
      if (res.offline) showHandoff();
    }).catch(function () {
      typing.remove();
      addBubble('assistant', "Sorry, I couldn't connect just now. Please try again, or tap below to email our team.");
    }).then(function () {
      state.busy = false; sendBtn.disabled = false; save();
    });
  }

  function quickAnswer(question, answer) {
    state.messages.push({ role: 'user', content: question });
    state.messages.push({ role: 'assistant', content: answer });
    addBubble('user', question); addBubble('assistant', answer);
    newBtn.hidden = false; save();
  }

  // ---------- email-the-team form (works without the AI) ----------
  function showHandoff() {
    if (body.querySelector('.tsc-handoff')) { scroll(); return; }
    var f = el('form', 'tsc-handoff');
    f.innerHTML =
      '<h3>Email our team</h3>' +
      '<input name="name" autocomplete="name" placeholder="Your name" maxlength="80">' +
      '<input name="email" type="email" autocomplete="email" placeholder="Your email" required maxlength="120">' +
      '<input name="orderNumber" placeholder="Order number (optional)" maxlength="30">' +
      '<textarea name="message" placeholder="How can we help?" required maxlength="3000"></textarea>' +
      '<p class="tsc-err" hidden></p>' +
      '<div class="tsc-row"><button type="button" class="tsc-btn tsc-ghost">Cancel</button><button type="submit" class="tsc-btn">Send</button></div>';
    f.elements.name.value = root.dataset.customerName || '';
    f.elements.email.value = root.dataset.customerEmail || '';
    var err = f.querySelector('.tsc-err');
    f.querySelector('.tsc-ghost').addEventListener('click', function () { f.remove(); });
    f.addEventListener('submit', function (e) {
      e.preventDefault();
      var btn = f.querySelector('[type=submit]'); btn.disabled = true; err.hidden = true;
      post('/handoff', {
        name: f.elements.name.value, email: f.elements.email.value,
        orderNumber: f.elements.orderNumber.value, message: f.elements.message.value,
        transcript: state.messages.slice(-20), pageUrl: location.href.split('#')[0],
      }).then(function (res) {
        if (res.ok) {
          f.remove();
          var msg = "Thanks! We've sent your message to our team. They reply by email within 24 business hours (Mon–Fri).";
          state.messages.push({ role: 'assistant', content: msg }); addBubble('assistant', msg); save();
        } else { err.textContent = res.error || 'Could not send. Please email sales@twosistersthelabel.com.'; err.hidden = false; btn.disabled = false; }
      }).catch(function () { err.textContent = 'Could not send. Please email sales@twosistersthelabel.com.'; err.hidden = false; btn.disabled = false; });
    });
    body.appendChild(f); scroll();
    f.elements[f.elements.email.value ? 'message' : 'name'].focus();
  }

  // ---------- events ----------
  function autosize() { input.style.height = 'auto'; input.style.height = Math.min(input.scrollHeight, 110) + 'px'; }
  launcher.addEventListener('click', function () { setOpen(true); });
  root.querySelector('.tsc-close').addEventListener('click', function () { setOpen(false); launcher.focus(); });
  root.querySelector('.tsc-team').addEventListener('click', showHandoff);
  newBtn.addEventListener('click', function () {
    if (state.busy) return;
    state.messages = []; save(); drawAll(); input.value = ''; autosize(); input.focus();
  });
  form.addEventListener('submit', function (e) { e.preventDefault(); send(input.value); });
  input.addEventListener('input', autosize);
  input.addEventListener('keydown', function (e) {
    if (e.key === 'Enter' && !e.shiftKey && !e.isComposing) { e.preventDefault(); send(input.value); }
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && state.open) setOpen(false); });

  // Other buttons on the site can open the chat: <a href="#chat"> or window.tsChat.open()
  window.tsChat = { open: function () { setOpen(true); }, close: function () { setOpen(false); } };
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('a[href="#chat"]');
    if (a) { e.preventDefault(); setOpen(true); }
  });

  drawAll();
  if (state.open) setOpen(true);
})();

/* Twosisters — phone-only "Get 10% off" side tab, styled like the Rewards button.
   Sits on top of Attentive's own teaser (made invisible, rotated under the tab) so taps still open the Attentive sign-up. */
(function () {
  'use strict';
  if (window.__tsOfferTab) return;
  window.__tsOfferTab = true;
  var css = '@media (max-width:767px){' +
    'iframe#attentive_creative.ts-att-teaser{left:0 !important;right:auto !important;bottom:auto !important;top:52vh !important;transform-origin:0 100% !important;transform:rotate(90deg) !important;opacity:0.01 !important}' +
    '.ts-offer-tab.is-on{display:flex}' +
    '}' +
    '.ts-offer-tab{position:fixed;left:0;top:calc(52vh + 60px);z-index:2147483647;pointer-events:none;writing-mode:vertical-rl;transform:rotate(180deg);background:rgb(243,229,245);color:#000;font-family:Jost,sans-serif;font-size:14px;font-weight:400;letter-spacing:.04em;line-height:1;padding:0 12px;height:150px;display:none;align-items:center;justify-content:center;border-radius:0 12px 12px 0;box-shadow:0 2px 10px rgba(0,0,0,.12)}';
  function init() {
    var st = document.createElement('style'); st.textContent = css; document.head.appendChild(st);
    var tab = document.createElement('div');
    tab.className = 'ts-offer-tab'; tab.setAttribute('aria-hidden', 'true'); tab.textContent = 'Get 10% off';
    document.body.appendChild(tab);
    setInterval(function () {
      var f = document.getElementById('attentive_creative');
      var h = f ? (parseFloat(f.style.height) || 0) : 0;
      var teaser = !!f && h > 0 && h <= 120 && f.style.visibility !== 'hidden' && f.style.opacity !== '0';
      if (f) f.classList.toggle('ts-att-teaser', teaser);
      tab.classList.toggle('is-on', teaser);
    }, 400);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
